import React, { Component, Fragment } from "react"
import styles from "./styles"
import { withStyles } from "@material-ui/styles"
import {
  Typography,
  Button,
  Fab,
  Hidden,
  Box,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  TextField,
} from "@material-ui/core"
import Select from "react-select"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import AutoComplete from "../../components/AutoComplete"
import classNames from "classnames"
import { primaryColor, mainColor } from "../../utils/color"
import { getCurrentHost } from "../../utils/getHost"
import Slide from "@material-ui/core/Slide"

const selectStyles = {
  control: styles => ({
    ...styles,
    borderRadius: "20px",
    backgroundColor: "#faf7f7",
    borderColor: mainColor,
    boxShadow: mainColor,
    color: mainColor,
    "&:hover": {
      borderColor: mainColor,
      backgroundColor: "rgba(0, 0, 0, 0.23)",
    },
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    backgroundColor: isSelected ? primaryColor : "none",
    ":hover": {
      backgroundColor: primaryColor,
    },
  }),
  singleValue: styles => ({
    ...styles,
    color: mainColor,
  }),
}

class CalendarHeaderToolbar extends Component {
  state = {
    isHovering: null,
    isClearable: false,
    isDisabled: false,
    isLoading: false,
    isRtl: false,
    isSearchable: true,
    showFilters: false,
  }

  toggleClearable = () =>
    this.setState(state => ({ isClearable: !state.isClearable }))
  toggleDisabled = () =>
    this.setState(state => ({ isDisabled: !state.isDisabled }))
  toggleLoading = () =>
    this.setState(state => ({ isLoading: !state.isLoading }))
  toggleRtl = () => this.setState(state => ({ isRtl: !state.isRtl }))
  toggleSearchable = () =>
    this.setState(state => ({ isSearchable: !state.isSearchable }))
  showFilters = () =>
    this.setState(state => ({ showFilters: !state.showFilters }))

  render() {
    const { props } = this

    const {
      dateShowRange,
      dateOptions,
      defaultDateOption,
      defaultFilters,
      classes,
      defaultFiltersSwitch,
      toggleFilterSwitch,
      viewOptions,
      defaultViewOption,
    } = props

    return (
      <Fragment>
        {/* WEB VIEW */}
        <Hidden smDown>
          <div
            style={{
              backgroundColor: "#faf7f7",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "30px",
            }}
          >
            <Button
              onClick={() => this.showFilters()}
              color="primary"
              variant="contained"
            >
              Filter My Shoots
            </Button>
            {this.state.showFilters && (
              <Slide
                direction="right"
                in={this.state.showFilters}
                mountOnEnter
                unmountOnExit
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Fab
                    size="small"
                    color="primary"
                    className={classes.legendButton}
                    onClick={() =>
                      this.props.handleToolbarControls(
                        defaultViewOption.label,
                        "controls",
                        "Prev"
                      )
                    }
                  >
                    <NavigateBeforeIcon className={classes.controlIcon} />
                  </Fab>

                  <Fab
                    size="small"
                    color="primary"
                    className={classes.legendButton}
                    style={{ marginLeft: "15px" }}
                    onClick={() =>
                      this.props.handleToolbarControls(
                        defaultViewOption.label,
                        "controls",
                        "Next"
                      )
                    }
                  >
                    <NavigateNextIcon className={classes.controlIcon} />
                  </Fab>

                  <Typography
                    variant="h2"
                    style={{
                      fontSize: "1.5rem",
                      marginLeft: "32px",
                      fontWeight: 600,
                      color: "#afacbe",
                    }}
                  >
                    {dateShowRange}
                  </Typography>

                  <Button
                    variant="outlined"
                    onClick={() =>
                      this.props.handleToolbarControls(
                        defaultViewOption.label,
                        "date",
                        "today"
                      )
                    }
                    className={props.classes.outlineButton}
                  >
                    Today
                  </Button>

                  <Select
                    className={props.classes.dayOptionsSelect}
                    classNamePrefix="select"
                    defaultValue={defaultDateOption}
                    isDisabled={this.state.isDisabled}
                    isLoading={this.state.isLoading}
                    isClearable={this.state.isClearable}
                    isRtl={this.state.isRtl}
                    isSearchable={this.state.isSearchable}
                    name="name"
                    styles={selectStyles}
                    options={dateOptions}
                    onChange={option => {
                      this.props.handleToolbarControls(
                        defaultViewOption.label,
                        "date",
                        dateOptions.find(x => x.value === option.value).label
                      )
                    }}
                  />

                  <Select
                    className={props.classes.dayOptionsSelect}
                    classNamePrefix="select"
                    color="#730303"
                    defaultValue={defaultViewOption}
                    isDisabled={this.state.isDisabled}
                    isLoading={this.state.isLoading}
                    isClearable={this.state.isClearable}
                    isRtl={this.state.isRtl}
                    isSearchable={this.state.isSearchable}
                    name="name"
                    styles={selectStyles}
                    options={viewOptions}
                    onChange={option => {
                      this.props.handleViewChange(
                        defaultViewOption.label,
                        "view",
                        viewOptions.find(x => x.value === option.value).label
                      )
                    }}
                  />
                </div>
              </Slide>
            )}

            <div style={{ display: "flex" }}>
              <Fragment>
                <TextField
                  variant="outlined"
                  value={props.search}
                  onChange={e => this.props.searchOnChange(e)}
                  label="Search Here"
                  margin="dense"
                />
              </Fragment>
            </div>
          </div>
        </Hidden>

        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <Fragment>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#faf7f7",
                justifyContent: "space-evenly",
                paddingTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <TextField
                variant="outlined"
                value={props.search}
                onChange={e => this.props.searchOnChange(e)}
                label="Search Here"
                margin="dense"
              />
            </div>
          </Fragment>

          <Fragment>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#faf7f7",
                justifyContent: "space-evenly",
                paddingTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <Fab
                size="small"
                color="primary"
                className={classes.legendButton}
                onClick={() =>
                  this.props.handleToolbarControls(
                    defaultViewOption.label,
                    "controls",
                    "Prev"
                  )
                }
              >
                <NavigateBeforeIcon className={classes.controlIcon} />
              </Fab>

              <Typography
                variant="h2"
                style={{ fontSize: "1.2rem", fontWeight: 600 }}
              >
                {dateShowRange}
              </Typography>

              <Fab
                size="small"
                color="primary"
                className={classes.legendButton}
                style={{ marginLeft: "15px" }}
                onClick={() =>
                  this.props.handleToolbarControls(
                    defaultViewOption.label,
                    "controls",
                    "Next"
                  )
                }
              >
                <NavigateNextIcon className={classes.controlIcon} />
              </Fab>
            </div>
          </Fragment>
          <Fragment>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#faf7f7",
                justifyContent: "space-evenly",
              }}
            >
              <ExpansionPanel className={classes.collapseStyles}>
                <ExpansionPanelSummary
                  className={classes.collapseSummary}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box
                    component="div"
                    m={1}
                    className={classes.collapseSummaryRow}
                  >
                    <Typography
                      variant="p"
                      className={classes.activeCollapseOption}
                    >
                      Date Options
                    </Typography>
                  </Box>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.collapseDetails}>
                  <Box
                    component="div"
                    m={1}
                    className={classes.collapseDetailsContainer}
                  >
                    {dateOptions &&
                      dateOptions.map((option, i) => (
                        <Box
                          component="div"
                          m={1}
                          Key={i}
                          className={classes.collapseDetailsRow}
                          onClick={() =>
                            this.props.handleToolbarControls(
                              defaultViewOption.label,
                              "date",
                              option.label
                            )
                          }
                        >
                          <Typography
                            variant="p"
                            className={
                              option.value === defaultDateOption.value
                                ? classes.activeCollapseOption
                                : {}
                            }
                          >
                            {option.label}
                          </Typography>
                        </Box>
                      ))}
                  </Box>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </Fragment>

          <Fragment>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#faf7f7",
                justifyContent: "space-evenly",
              }}
            >
              <ExpansionPanel className={classes.collapseStyles}>
                <ExpansionPanelSummary
                  className={classes.collapseSummary}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box
                    component="div"
                    m={1}
                    className={classes.collapseSummaryRow}
                  >
                    <Typography
                      variant="p"
                      className={classes.activeCollapseOption}
                    >
                      View Options
                    </Typography>
                  </Box>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.collapseDetails}>
                  <Box
                    component="div"
                    m={1}
                    className={classes.collapseDetailsContainer}
                  >
                    {viewOptions &&
                      viewOptions.map((option, i) => (
                        <Box
                          component="div"
                          m={1}
                          Key={i}
                          className={classes.collapseDetailsRow}
                          onClick={() =>
                            this.props.handleViewChange(
                              defaultViewOption.label,
                              "view",
                              option.label
                            )
                          }
                        >
                          <Typography
                            variant="p"
                            className={
                              option.value === defaultViewOption.value
                                ? classes.activeCollapseOption
                                : {}
                            }
                          >
                            {option.label}
                          </Typography>
                        </Box>
                      ))}
                  </Box>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </Fragment>
        </Hidden>
      </Fragment>
    )
  }
}

export default withStyles(styles)(CalendarHeaderToolbar)
